import type { VueQueryPluginOptions } from '@tanstack/vue-query';

import { VueQueryPlugin } from '@tanstack/vue-query';

import { Duration, MILLISECONDS } from '@/lib/date-time/duration';

export function createTanstackQuery(): [typeof VueQueryPlugin, VueQueryPluginOptions] {
  const options: VueQueryPluginOptions = {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          gcTime: 30 * Duration.MINUTE * MILLISECONDS,
          refetchOnWindowFocus: false,
          retry: false,
        },
      },
    },
  };

  return [VueQueryPlugin, options];
}
